<script>
// This component makes its children collapsable
export default {
  props: {
    modelValue: { 
      type: Boolean
    },
    borderBottomWidth: {
      type: Number,
      default: 1,
    },
    transitionDuration: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      isExpanded: this.modelValue,
      isCollapsed: !this.modelValue,
    };
  },
  computed: {
    expandedHeight() {
      return `${this.$refs.boxContent.scrollHeight}px`;
    },
    elementStyle() {
      // Default style, is always applied
      const style = {
        transition: `height ${this.transitionDuration}ms`,
      };
      if (this.isExpanded) {
        // The box is expanded, allow content to be visible
        return {
          ...style,
          height: "auto",
          overflow: "visible",
        };
      }
      if (this.modelValue) {
        // The box is expanding, leave the default border but still hide overflow
        return {
          ...style,
          overflow: "hidden",
        };
      }
      if (!this.isCollapsed) {
        // Box is collapsing. Hide overflow
        return {
          ...style,
          overflow: "hidden",
        };
      }
      // The box is collapsed. No border, hide overflow
      return {
        ...style,
        borderBottomWidth: "0px",
        overflow: "hidden",
      };
    },
  },
  watch: {
    modelValue(val) {
      if (val === true) {
        this.expand();
      } else {
        this.collapse();
      }
    },
  },
  mounted() {
    this.$refs.boxContent.addEventListener(
      "transitionend",
      this.handleTransitionEnd
    );
    if (this.modelValue === false) {
      this.$refs.boxContent.style.height = "0px";
    }
  },
  beforeUnmount() {
    this.$refs.boxContent.removeEventListener(
      "transitionend",
      this.handleTransitionEnd
    );
  },
  methods: {
    collapse() {
      const element = this.$refs.boxContent;
      this.isExpanded = false;
      const elementTransition = element.style.transition;
      element.style.transition = "";
      requestAnimationFrame(() => {
        element.style.height = this.expandedHeight;
        element.style.transition = elementTransition;
        requestAnimationFrame(() => {
          element.style.height = "0px";
        });
      });
    },
    expand() {
      this.isCollapsed = false;
      const element = this.$refs.boxContent;
      element.style.height = this.expandedHeight;
      element.style.borderBottomWidth = `${this.borderBottomWidth}px`;
    },
    handleTransitionEnd() {
      const element = this.$refs.boxContent;
      if (element.style.height !== "0px") {
        this.isExpanded = true;
      } else {
        this.isCollapsed = true;
      }
    },
  },
};
</script>

<template>
  <div ref="boxContent" class="collapsable" :style="elementStyle">
    <slot />
  </div>
</template>


<style scoped>
.collapsable {
  backface-visibility: hidden;
  transform: translateZ(0);
  will-change: height;
}
</style>
